import { useFormContext, useFormState } from 'react-hook-form';

export const useFieldValidity = (name: string) => {
  const { getFieldState } = useFormContext();
  const { invalid, isTouched, isDirty, error } = getFieldState(name);
  const { isSubmitted } = useFormState();
  const shouldShowValidation = isTouched || isDirty || isSubmitted;
  const isValid = shouldShowValidation && !invalid;
  const visibleInvalid = shouldShowValidation && invalid;
  const visibleError = shouldShowValidation ? error : undefined;

  return {
    isValid,
    isTouched,
    isDirty,
    invalid: visibleInvalid,
    error: visibleError,
  };
};
